<template>
  <div class="player-dot-component">
    <div class="player-dot-container"
         v-for="n in dotList"
         :key="n"
    >
      <span class="player-dot-item player-dot-item-large"
            v-if="n > 1"
      ></span>
      <span class="player-dot-item"></span>
      <span class="player-dot-item"></span>
      <span class="player-dot-item"></span>
      <span class="player-dot-item player-dot-item-large"></span>
      <span class="player-dot-item"></span>
      <span class="player-dot-item"></span>
      <span class="player-dot-item"></span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TrainingPlayerDot',
    props: {
      duration: {
        type: Number,
        required: true,
      },
    },
    computed: {
      dotList() {
        if (this.duration <= 10) {
          return 0;
        }
        if (this.duration > 10 && this.duration <= 20) {
          return 1;
        }
        return 2;
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .player-dot-component {
    display: inline-flex;
    align-items: center;
  }

  .player-dot-container {
    display: inline-flex;
    align-items: center;
  }

  @player-dot-size: 6px;
  @player-dot-large-size: 10px;
  @player-dot-background: #afeeec;
  @player-dot-background-lighter: #ccf5f4;
  .player-dot-item {
    flex-shrink: 0;
    display: inline-block;
    margin: 0 @size-extra-small / 2;
    width: @player-dot-size;
    height: @player-dot-size;
    border-radius: @border-radius-round;
    background-color: @player-dot-background-lighter;
    &-large {
      width: @player-dot-large-size;
      height: @player-dot-large-size;
      border-radius: @border-radius-round;
      background-color: @player-dot-background;
    }
  }
</style>
